import { useSpinner } from "@components/SpinnerContext";
import accomodationService from "@services/accomodation.service"
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Page404 from "@pages/NotFoundPage"
import { Contact } from "@models/contact.model";
import { useTranslation } from "react-i18next";
import sessionStorageService from "@services/sessionStorage.service";
import PageHeader from "@components/PageHeader";
import ContactLink from "@components/ContactLink";
import { triggerMail, triggerPhone } from "@utils/sharedFunctions";
import LinkComponent from "@components/LinkComponent";
import SocialComponent from "@components/SocialComponent";

const ContactPage = () => {
    const { t } = useTranslation();
    const { showSpinner, hideSpinner } = useSpinner();
    const [isPageNotFound, setIsPageNotFound] = useState(false);
    const [contact, setContact] = useState<Contact | undefined>(undefined);
    const [otherWebsites, setOtherWebsites] = useState<[string, string][]>([]);
    const location = useLocation();

    useEffect(() => {
        async function getContacts(id: string) {
            try {
                showSpinner();
                const response = await accomodationService.getContact(id);
                sessionStorage.setItem('contact', JSON.stringify(response));
                setContact(response);
            } catch (error) {
                setIsPageNotFound(true);
                console.log(error);
            } finally {
                hideSpinner();
            }
        }

        const cached = sessionStorageService.getContactSS()
        if (cached) {
            setContact(cached);
        } else {
            const qrCodeId = location.pathname.split("/")[1];
            getContacts(qrCodeId);
        }
    }, [])
   
    useEffect(() => {
        const other = contact?.otherWebsites;

        if (!other) return;

        if (other instanceof Map) {
            setOtherWebsites(Array.from(other.entries()));
        } else {
            setOtherWebsites(Object.entries(other));
        }
    }, [contact]);

    
    
    return (
        <div className="mx-3 mb-5 mb-lg-0">

            {isPageNotFound ? (<Page404 />) : (
                <div>
                    <div className="sticky-top sticky-header border-bottom border-light">
                    <PageHeader pageTitle={t("text.contact")} flagSearch={false} flag={false} />
                    </div>
                    <div className="mt-4 text-white" style={{ whiteSpace: 'pre-line' }}>
                        <p>
                            Whatsapp:{" "}
                            {contact?.whatsapp && (
                                <a
                                    href={`https://wa.me/${contact.whatsapp.replace(/\D/g, "")}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    role="button"
                                    className="link-text"
                                >
                                    {contact.whatsapp}
                                </a>
                            )}
                        </p>

                        <ContactLink type="tel" value={contact?.mobileNumber} label="Mobile" func={triggerPhone} />
                        <ContactLink type="tel" value={contact?.telephoneNumber} label={t("text.telephone")} func={triggerPhone} />
                        <ContactLink type="mailto" value={contact?.email} label="Email" func={triggerMail} />

                        <div className="d-flex flex-column">
                            {contact?.airbnb ? <LinkComponent 
                                socialName={"Airbnb"} 
                                url={contact?.airbnb}
                            /> : <></>}
                            {contact?.booking ? <LinkComponent 
                                socialName={"Booking"} 
                                url={contact?.booking}
                            />: <></>}
                            {contact?.website ? <LinkComponent 
                                socialName={"WebSite"} 
                                url={contact?.website}
                            />:<div></div>}
                            {otherWebsites.map(([key, value], index) => (
                                <div key={index}>
                                    <LinkComponent 
                                        socialName={key}    
                                        url={value}
                                    /> 
                                </div>
                            ))}
                         
                        </div>
                        <div className="d-flex gap-4 justify-content-around mt-5 social-icon-wrapper">
                            <SocialComponent
                                socialName={"facebook"}
                                value={contact?.facebook}
                            />
                            <SocialComponent
                                socialName={"youtube"}
                                value={contact?.youtube}
                            />
                            <SocialComponent
                                socialName={"instagram"}
                                value={contact?.instagram}
                            />
                            <SocialComponent
                                socialName={"tiktok"}
                                value={contact?.tiktok}
                            />
                        </div>
                    </div>
                </div>)}

        </div>
    )
}
export default ContactPage